import React, {Component} from 'react';
import css from './Accordion.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';


/**
 * @class
 *
 * An accordion component -- provides an expandable details-summary view.
 * Clicking on the header expands/collapses the content section.
 *
 * @prop header (React Markup): Markup for the header/summary.
 * @prop content (React Markup): Markup for the content/details section.
 *
 * @example
 *  <Accordion
 *      header={
 *          <span>Foo</span>
 *      }
 *
 *      content={
 *          <div>
 *              <div>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis, ullam!</div>
 *              <button onClick={() => this.handleButtonSubmit()}>Submit</button>
 *          </div>
 *      }
 *  />
 */
const Accordion = class extends Component{
    // ---------- state: ----------
    state = {
        isActive: false
    };

    // ---------- methods: ----------
    /**
     * @method
     * @methodOf Accordion
     *
     * Toggles between active (showing details/content) and inactive (hide details/content).
     */
    toggleAccordion = () => {
        this.setState({
            isActive: !this.state.isActive
        })
        console.log(this.props.user);
    };

    render() {
        // console.log(this.props.header);
        // console.log(this.props.content);
        return(
            <div className={css.Accordion}>
                <span className={this.state.isActive ? `${css.Accordion__Icon} ${css.Active}` : css.Accordion__Icon} onClick={() => this.toggleAccordion()} >
                    <FontAwesomeIcon icon={faCaretRight}/>
                </span>
                <div className={this.state.isActive ? `${css.Accordion__Header} ${css.Active}` : css.Accordion__Header}>
                    { this.props.header }
                </div>
                <div className={this.state.isActive ? `${css.Accordion__Content} ${css.Active}` : css.Accordion__Content}>
                    { this.props.content }
                </div>
            </div>
        );
    }
}

export default Accordion;
